<template>
  <div class="login-card">
    <div
      v-if="hasLeftColumnSlot"
      class="login-card__left-column"
    >
      <slot name="left-column" />
    </div>

    <div
      v-if="hasRightColumnSlot"
      class="login-card__right-column"
    >
      <slot name="right-column" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginCard",

  computed: {
    hasLeftColumnSlot() {
      return !!(this.$slots && this.$slots['left-column']);
    },

    hasRightColumnSlot() {
      return !!(this.$slots && this.$slots['right-column']);
    }
  }
}
</script>
